import React, { useEffect, useState } from 'react';
import { Form, Header, Pagination, Segment, Table } from 'semantic-ui-react';
import { API, showError, timestamp2string } from '../../helpers';
import { ITEMS_PER_PAGE } from '../../constants';
import { renderQuota } from '../../helpers/render';

// 租户管理员只读人工充值记录，租户由服务端按绑定自动限定
const TenantAdminTopups = () => {
  const [keyword, setKeyword] = useState('');
  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);

  const loadGrants = async (startIdx, kw = keyword) => {
    setLoading(true);
    const res = await API.get(
      `/api/tenant_admin/manual_topup?p=${startIdx}&keyword=${encodeURIComponent(kw.trim())}`
    );
    const { success, message, data } = res.data;
    if (success) {
      if (startIdx === 0) {
        setGrants(data || []);
      } else {
        setGrants((prev) => [...prev, ...(data || [])]);
      }
    } else {
      showError(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadGrants(0).then();
  }, []);

  const refresh = async () => {
    setActivePage(1);
    await loadGrants(0);
  };

  const onPaginationChange = (e, { activePage: page }) => {
    (async () => {
      if (page === Math.ceil(grants.length / ITEMS_PER_PAGE) + 1) {
        await loadGrants(page - 1);
      }
      setActivePage(page);
    })();
  };

  return (
    <Segment loading={loading}>
      <Header as='h3'>本租户充值记录</Header>
      <Form>
        <Form.Group>
          <Form.Input
            fluid
            width={6}
            label='搜索用户名 / 操作人'
            placeholder='前缀匹配'
            value={keyword}
            onChange={(e, { value }) => setKeyword(value)}
          />
          <Form.Button fluid width={2} label='操作' onClick={refresh}>
            查询
          </Form.Button>
        </Form.Group>
      </Form>

      <Table basic compact size='small'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>时间</Table.HeaderCell>
            <Table.HeaderCell>用户</Table.HeaderCell>
            <Table.HeaderCell>操作人</Table.HeaderCell>
            <Table.HeaderCell>金额</Table.HeaderCell>
            <Table.HeaderCell>额度</Table.HeaderCell>
            <Table.HeaderCell>备注</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {grants
            .slice((activePage - 1) * ITEMS_PER_PAGE, activePage * ITEMS_PER_PAGE)
            .map((grant) => (
              <Table.Row key={grant.id}>
                <Table.Cell>{timestamp2string(grant.created_at)}</Table.Cell>
                <Table.Cell>{grant.username}</Table.Cell>
                <Table.Cell>{grant.operator_username}</Table.Cell>
                <Table.Cell>¥{(grant.amount_fen / 100).toFixed(2)}</Table.Cell>
                <Table.Cell>{renderQuota(grant.granted_quota, 6)}</Table.Cell>
                <Table.Cell>{grant.note || '-'}</Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan='6'>
              <Pagination
                floated='right'
                activePage={activePage}
                onPageChange={onPaginationChange}
                size='small'
                siblingRange={1}
                totalPages={
                  Math.ceil(grants.length / ITEMS_PER_PAGE) +
                  (grants.length % ITEMS_PER_PAGE === 0 ? 1 : 0)
                }
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Segment>
  );
};

export default TenantAdminTopups;
